import { resolveImagePath } from '@/utils/imageMap';

interface PartnerLogo {
  name: string;
  imagePath: string;
  alt: string;
}

const partnerLogos: PartnerLogo[] = [
  // First row
  {
    name: 'Avfuel',
    imagePath: '/images/avfuel-logo.jpg',
    alt: 'Avfuel logo'
  },
  {
    name: 'Textron Aviation',
    imagePath: '/images/textron-logo.png',
    alt: 'Textron Aviation logo'
  },
  {
    name: 'Avidyne',
    imagePath: '/images/avidyne-logo.jpg',
    alt: 'Avidyne logo'
  },
  {
    name: 'McCauley',
    imagePath: '/images/mccauley-logo.png',
    alt: 'McCauley logo'
  },
  // Second row
  {
    name: 'Garmin',
    imagePath: '/images/garmin-logo.jpg',
    alt: 'Garmin logo'
  },
  {
    name: 'L3 Communications',
    imagePath: '/images/l3-communications-logo.jpg',
    alt: 'L3 Communications Avionics Systems logo'
  },
  {
    name: 'NBAA',
    imagePath: '/images/nbaa-logo.jpg',
    alt: 'NBAA logo'
  },
  {
    name: 'Bendix King',
    imagePath: '/images/bendixking-logo.jpg',
    alt: 'Bendix King logo'
  }
];

export function PartnerLogos() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 items-center justify-items-center">
          {partnerLogos.map((logo) => (
            <div
              key={logo.name}
              className="flex items-center justify-center h-20 w-full"
            >
              <img
                src={resolveImagePath(logo.imagePath)}
                alt={logo.alt}
                className="max-h-full max-w-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}